<div class="filled-orders">
	<app-table
		[statesColumns]="statesColumns()"
		[settings]="{
			size: 'md',
			spreadContent: 'space-between',
			rowBorder: true,
			emptyTextPath: 'orders.empty',
		}"
		[items]="ordersResponse()?.orders ?? []"
		[isLoading]="isLoadingOrders()"
	>
		<app-table-column
			[settings]="{
				titlePath: 'orders.ticker',
				column: columnsFilledOrdersEnum.tickerCompany,
				minWidthPx: 90,
				maxWidthPx: 150,
			}"
		>
			<ng-template let-item="item">
				<div class="ticker-column">
					@if (item.order_class === orderClassEnum.OCO) {
						<div class="ticker-oco">
							<img
								class="icon nested-double-arrow"
								src="/images/icons/nested-double-arrow.svg"
								alt="nested-double-arrow"
							/>
							<div class="ticker-info">
								<ng-container
									*ngTemplateOutlet="
										tickerDefault;
										context: { symbol: item.symbol, assetName: item.asset_name || item.symbol }
									"
								/>
								@if (item.children_order?.length) {
									<ng-container
										*ngTemplateOutlet="
											tickerDefault;
											context: { symbol: item.symbol, assetName: item.asset_name || item.symbol }
										"
									/>
								}
							</div>
						</div>
					} @else if (item.order_class === orderClassEnum.OTO) {
						<div class="ticker-oto">
							<ng-container
								*ngTemplateOutlet="
									tickerDefault;
									context: { symbol: item.symbol, assetName: item.asset_name || item.symbol }
								"
							/>
							@if (item.children_order?.length) {
								<div class="nested-icon">
									<img
										class="icon nested-arrow"
										src="/images/icons/nested-arrow.svg"
										alt="nested-arrow"
									/>
									<ng-container *ngTemplateOutlet="tickerDefault; context: { symbol: item.symbol }" />
								</div>
							}
						</div>
					} @else if (item.order_class === orderClassEnum.BRACKET) {
						<div class="ticker-bracket">
							<ng-container
								*ngTemplateOutlet="
									tickerDefault;
									context: { symbol: item.symbol, assetName: item.asset_name || item.symbol }
								"
							/>
							@if (item.children_order?.length) {
								<div class="nested-icon">
									<img
										class="icon nested-arrow"
										src="/images/icons/nested-arrow.svg"
										alt="nested-arrow"
									/>
									<ng-container *ngTemplateOutlet="tickerDefault; context: { symbol: item.symbol }" />
								</div>
							}
						</div>
					} @else {
						<ng-container
							*ngTemplateOutlet="
								tickerDefault;
								context: { symbol: item.symbol, assetName: item.asset_name || item.symbol }
							"
						/>
					}
				</div>

				<ng-template
					#tickerDefault
					let-symbol="symbol"
					let-assetName="assetName"
				>
					<div class="ticker-default">
						<span
							class="symbol"
							(click)="setLiveTicker(symbol)"
							>{{ symbol }}</span
						>
						@if (assetName) {
							<span class="exchange">{{ assetName }}</span>
						}
					</div>
				</ng-template>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'orders.operation',
				column: columnsFilledOrdersEnum.operation,
				minWidthPx: 70,
				maxWidthPx: 100,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="cell-column">
					<span
						class="text"
						highlight
						[isPositive]="item.side === orderSideEnum.BUY"
						[isNegative]="item.side === orderSideEnum.SELL"
					>
						{{ 'orders.side.' + item.side | translate }}
					</span>
					@if (item.children_order?.length) {
						<div class="side-translation">
							@for (child of item.children_order; track child.id) {
								<span
									class="text"
									highlight
									[isPositive]="child.side === orderSideEnum.BUY"
									[isNegative]="child.side === orderSideEnum.SELL"
								>
									{{ 'orders.side.' + child.side | translate }}
								</span>
							}
						</div>
					}
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'orders.sum',
				column: columnsFilledOrdersEnum.sum,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="cell-column">
					<span
						secret
						[isSecret]="isSecret()"
						[secretCount]="4"
						class="text"
						>{{ calcQtyAvailable(item) | price }}</span
					>
					@if (item.children_order?.length) {
						<div class="side-translation">
							@for (child of item.children_order; track child.id) {
								<span
									secret
									[isSecret]="isSecret()"
									[secretCount]="4"
									class="text child-order"
									>{{ child.qty * child.filled_avg_price | price }}</span
								>
							}
						</div>
					}
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'orders.profitability',
				column: columnsFilledOrdersEnum.profitability,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="cell-column">
					<div class="profitability">
						<span
							class="text"
							secret
							[isSecret]="isSecret()"
							[secretCount]="4"
							highlight
							[isPositive]="(item.profit_cash ?? 0) > 0"
							[isNegative]="(item.profit_cash ?? 0) < 0"
							[isNeutral]="!item.is_close_position || !item.profit_cash"
						>
							{{ !item.is_close_position ? '-' : (item.profit_cash | profit: 'dollar') }}
						</span>
						<span
							class="text"
							highlight
							[isPositive]="(item.profit_percent ?? 0) > 0"
							[isNegative]="(item.profit_percent ?? 0) < 0"
							[isNeutral]="!item.is_close_position || !item.profit_percent"
							>{{ !item.is_close_position ? '-' : (item.profit_percent | profit: 'percent') }}</span
						>
					</div>
					@if (item.children_order?.length) {
						<div class="side-translation">
							@for (child of item.children_order; track child.id) {
								<div class="profitability">
									<span
										class="text"
										highlight
										[isPositive]="child.profit_cash > 0"
										[isNegative]="child.profit_cash < 0"
										[isNeutral]="!child.profit_cash"
									>
										{{ child.profit_cash | profit: 'dollar' }}
									</span>
									<span
										class="text"
										highlight
										[isPositive]="child.profit_percent > 0"
										[isNegative]="child.profit_percent < 0"
										[isNeutral]="!child.profit_percent"
									>
										{{ child.profit_percent | profit: 'percent' }}
									</span>
								</div>
							}
						</div>
					}
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'orders.dateTime',
				column: columnsFilledOrdersEnum.dateTime,
				minWidthPx: 90,
				maxWidthPx: 100,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="cell-column">
					<div class="dates">
						<span class="text">{{ item.filled_at | date: 'dd.MM.yyyy' }}</span>
						<span class="time">{{ item.filled_at | date: 'HH:mm:ss' }}</span>
					</div>
					@if (item.children_order?.length) {
						<div class="side-translation">
							@for (child of item.children_order; track child.id) {
								<div class="dates">
									<span class="text">{{ child.filled_at | date: 'dd.MM.yyyy' }}</span>
									<span class="time">{{ child.filled_at | date: 'HH:mm:ss' }}</span>
								</div>
							}
						</div>
					}
				</div>
			</ng-template>
		</app-table-column>

		<app-table-actions>
			<ng-template let-item="item">
				<app-filled-orders-actions [order]="item" />
			</ng-template>
		</app-table-actions>

		<app-table-footer>
			<ng-template>
				<div class="footer">
					<div class="total">
						<span class="title">{{ 'orders.total' | translate }}:</span>
						<span
							class="value"
							[tuiSkeleton]="isLoadingOrders()"
							>{{ (ordersResponse()?.orders ?? []).length | quantity }}</span
						>
					</div>

					<app-pagination
						[isLoading]="isLoadingOrders()"
						[total]="ordersResponse()?.count ?? 0"
						[pageIndex]="ordersParams()?.page ?? 1"
						(pageChange)="onPageChange($event)"
					/>
				</div>
			</ng-template>
		</app-table-footer>
	</app-table>
</div>
